import type {ReactNode} from 'react';
import clsx from 'clsx';

import {PortableLink} from '@/modules/foundation/components/portable-text/portable-link';

import type {LinkFragment} from '../../link/query';
import {linkFragmentToHref} from '../../link/query';

type Props = {
	children: ReactNode;
	value: LinkFragment;
	theme?: 'light' | 'dark';
};

export const PortableLinkContainer = ({children, value, theme}: Props) => {
	return (
		<PortableLink
			href={linkFragmentToHref(value)}
			targetBlank={value?.targetBlank}
			className={clsx(theme === 'dark' && ['text-primary-45'])}
		>
			{children}
		</PortableLink>
	);
};
